function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "shopping_cart"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m9 16h8c.966 0 1.949-.682 2.288-1.585l2.298-6.128c.208-.558.15-1.134-.161-1.582s-.83-.705-1.425-.705h-12.486l-.363-2.178c-.171-1.022-1.115-1.822-2.151-1.822h-2c-.552 0-1 .447-1 1s.448 1 1 1h2c.062 0 .168.09.178.15l1.671 10.027c.171 1.023 1.115 1.823 2.151 1.823zm10.557-8-2.143 5.713c-.046.124-.282.287-.414.287h-8c-.062 0-.168-.09-.178-.15l-.975-5.85z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9.5 17c-1.378 0-2.5 1.121-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.122-2.5-2.5-2.5zm0 3c-.276 0-.5-.225-.5-.5s.224-.5.5-.5.5.225.5.5-.224.5-.5.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m19.5 17c-1.378 0-2.5 1.121-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.122-2.5-2.5-2.5zm0 3c-.276 0-.5-.225-.5-.5s.224-.5.5-.5.5.225.5.5-.224.5-.5.5z"
})));

var Svg105Shoppingcart = function Svg105Shoppingcart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg105Shoppingcart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/105-shopping cart.213f47eb.svg";
export { ForwardRef as ReactComponent };